import React, { useState, useRef } from "react";
import "../all css/testimonialsection.css";
import Slider from "react-slick";

import {
  BsFillArrowLeftSquareFill,
  BsFillArrowRightSquareFill,
} from "react-icons/bs";
import { MdPause } from "react-icons/md";
import CustDialogBox from "../../components/custom dialogbox/CustDialogBox";
const parth_img = require("../../assets/testimonial/parth.jpeg");
const video_img = require("../../assets/video_img_testimonial.png");
const play_img = require("../../assets/play_btn.png");
const black_quote1 = require("../../assets/blck_quote_1.png");
const black_quote2 = require("../../assets/blck_quote_2.png");
const video_hero_section = require("../../assets/hero_vdo.mp4");
const testimonial_img1 = require("../../assets/testimonial/DevprakashRajpoot.jpg");
const testimonial_img2 = require("../../assets/testimonial/kajol.jpg");
const videoImgPoster = require("../../assets/testimonial/video-poster-1.jpg");
const videoImgPoster1 = require("../../assets/testimonial/video-poster-2.jpg");
const videoImgPoster2 = require("../../assets/testimonial/video-poster-3.jpg");
const videoImgPoster3 = require("../../assets/testimonial/GaneshMPic.jpg");
const video1 = require("../../assets/testimonial/video-1.mp4");
const video2 = require("../../assets/testimonial/video-2.mp4");
const video3 = require("../../assets/testimonial/video-3.mp4");
const video4 = require("../../assets/testimonial/GaneshMarshale.mp4");

const allContent = [
  {
    posterName: testimonial_img1,
    contentPoster:
      "I cannot abstain from appreciating the DWEC team in realizing my dreams of studying abroad. The team had surpassed all expectations when it comes to; attention to detail, domain knowledge, and efficient laid engagement protocol made the experience more fulfilling than I expected.   ",
    title: "Devprakash Rajpoot",
    subTitle:
      "Graduate Certificate in Project Management, Conestoga College, Canada",
    contentType: "image",
  },
  {
    posterName: videoImgPoster,
    poster: video1,
    title: "Krishnav Arora",
    subTitle:
      "Bachelor's in Computer Science(Hons.), University Of Alberta, Canada",
    contentType: "Video",
  },
  {
    posterName: testimonial_img2,
    contentPoster:
      " My hand-holding started from profile creation and evaluation, selection of universities, application submission, test preparation, visa, and placement assistance. Though I was applying for a specialized course in medicine, I was never misguided by the team. They made me aware of financial implications, cost of living among others",
    title: "Kajol Kadel",
    subTitle:
      "Global Business Management (GBMT), Georgian College at ILAC, Canada",
    contentType: "image",
  },
  {
    posterName: videoImgPoster1,
    poster: video2,
    title: "Sai Shivani Palaparthi",
    subTitle:
      "Integrated Masters Program in Computer Science, University of Alabama at Birmingham, USA",
    contentType: "Video",
  },
  {
    posterName: parth_img,
    contentPoster:
      " I am glad that I had a chance to interact with most of the team members at DWEC and trust me the touchpoints were worth remembering. They have understood my preferences, fears, biases and turned them into strengths. My queries seemed too scary and demanding but the team has shown exemplary confidence, a sense of responsibility, and willingness to tackle all of them swiftly and efficiently.",
    title: "Parth Jindal",
    subTitle:
      "Graduate Certificate- International Business Management, Seneca College, Canada",
    contentType: "image",
  },

  {
    posterName: videoImgPoster2,
    poster: video3,
    title: "Kajol Yagneshkumar Kadel",
    subTitle:
      "Global Business Management (GBMT), Georgian College at ILAC, Canada",
    contentType: "Video",
  },
  {
    posterName: videoImgPoster3,
    poster: video4,
    title: "Ganesh Marshale",
    subTitle:
      "Graduate Certificate - Project Management, Algoma University, Canada",
    contentType: "Video",
  },
];

function TestimonialSection(props) {
  const customeSlider = React.useRef();
  const [playVideo, setPlayVideo] = useState(false);
  // const [toggleModal, setToggleModal] = React.useState(false);
  const [videoToRender, setVideoToRender] = useState(video_hero_section);

  const handlePlayVideo = (videoName) => {
    // if (!playVideo && !toggleModal) {
    //   setVideoToRender(videoName);
    //   setPlayVideo(true);
    //   setToggleModal(true);
    // } else {
    //   setPlayVideo(false);
    //   setToggleModal(false);
    // }
    setPlayVideo(true);
    setVideoToRender(videoName);
  };

  const gotoNext = () => {
    customeSlider.current.slickNext();
  };

  const gotoPrev = () => {
    console.log("hi");
    customeSlider.current.slickPrev();
  };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    // autoplay: true,
    initialSlide: 0,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const renderImgContent = allContent.map((content) => {
    if (content.contentType === "image") {
      return (
        <div key={Math.random()}>
          <div className="testimonial_img_text">
            <div className="testimonial_img_contnet_container_card">
              <div className="pink_container_img">
                <div className="testimonial_img_container">
                  <img src={content.posterName} alt="testimonial_img" />
                </div>
              </div>
              <div className="testimonial_content_container">
                <div className="testimonial_under_content_container">
                  <div className="paragraph_first_container">
                    <img
                      src={black_quote1}
                      alt="black_quote"
                      className="black_quote_one"
                    />
                  </div>
                  <div className="paragraph_sec_container">
                    <p className="extra_testimonial_content">
                      {content.contentPoster}
                    </p>
                  </div>
                  <div className="paragraph_third_container">
                    <img
                      src={black_quote2}
                      alt="black_quote"
                      className="black_quote_two"
                    />
                  </div>
                </div>
                <div className="testimonial_name_subname_container">
                  <p className="testimonial_name_text">{content.title}</p>
                  <p className="testimonial_subname_text">
                    {content.subTitle}{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div key={Math.random()}>
          <div className="testimonial_vdo_container">
            {playVideo && videoToRender === content.poster ? (
              <div className="video_main_container1">
                <video
                  autoPlay
                  className="video_testimonial_section1"
                  preload="auto"
                  playsInline
                >
                  <source src={content.poster} type="video/mp4" />
                </video>
                <div className="pause_btn_container">
                  <button
                    className="pause_btn_for_vdo"
                    onClick={() => setPlayVideo(false)}
                  >
                    <MdPause className="pause_icon_self" />
                  </button>
                </div>
              </div>
            ) : (
              <div className="testimonial_poster_container">
                <button
                  className="play_btn_testimonial_container"
                  onClick={() => handlePlayVideo(content.poster)}
                >
                  <img
                    className="testimonial_play_btn"
                    alt="play_btn"
                    src={play_img}
                  />
                </button>

                <img
                  className="poster_img"
                  alt="poster"
                  src={content.posterName}
                />
                <div className="name_subname_container">
                  <p className="title_text_vdo">{content.title}</p>
                  <p className="subtitle_text_vdo">{content.subTitle}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }
  });

  return (
    <section className="testimonial_section_main_contianer">
      <div className="study_destination_under_main_container">
        <div className="study_destination_title_sub_container">
          <p
            className="title_text wow pulse animated"
            data-wow-delay="500ms"
            data-wow-iteration="infinite"
            data-wow-duration="1s"
          >
            TESTIMONIALS
          </p>
          <p className="study_destination_sub_title_text"></p>
        </div>

        {/* {playVideo ? (
          <CustDialogBox
          open={toggleModal}
          onClose={() => {
            setPlayVideo(false);
            setToggleModal(false);
          }}
          >
          <div className="video_main_container">
          <video controls className="video_testimonial_section">
          <source src={videoToRender} type="video/mp4" />
          </video>
          </div>
          </CustDialogBox>
        ) : null} */}

        <div className="testimonial_slider_container">
          <Slider {...settings} ref={customeSlider}>
            {renderImgContent}
          </Slider>
        </div>

        <div className="btn_left_right_testimonial_container">
          <button
            className="prev_btn_testimonial same_btn_testimonial"
            onClick={() => gotoPrev()}
          >
            <BsFillArrowLeftSquareFill className="left_top_univercity_icon " />
          </button>

          <button
            className="next_btn_testimonial same_btn_testimonial"
            onClick={() => gotoNext()}
          >
            <BsFillArrowRightSquareFill className="left_top_univercity_icon " />
          </button>
        </div>
      </div>
    </section>
  );
}

export default TestimonialSection;
